<div class="container">
    <div class="column first-column">
      <div class="row">Blend 1 Vis. Grade</div>
      <select class="row" [(ngModel)]="selectedGrade[0]" (change)="onGradeChange()">
        @for (item of grades; track item) {
          <option [value]="item">{{ item }}</option>
        }
      </select>
    </div>
    <div class="column second-column">
        <div class="row ">Blend 2 Vis. Grade</div>
        <select class="row" [(ngModel)]="selectedGrade[1]" (change)="onGradeChange()">
          @for (item of grades; track item) {
            <option [value]="item">{{ item }}</option>
          }
        </select>
      </div>
</div>